export default __webpack_public_path__ + "static/media/engine.510c2ee5.svg";